import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import {
  NavController,
  ModalController,
  NavParams,
  AlertController,
  LoadingController,
} from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { IbraintreeTransaction } from "../interfaces/account-interface";
import { HttpProvider } from "../providers/http-provider.service";
import { NavigationExtras, Router } from "@angular/router";
import { SpinnerService } from "../providers/spinner-service.service";
declare var stripe: any;
declare var elements: any;
declare var braintree: any;
declare var cordova: any;

@Component({
  selector: "app-braintree-payment-methods-model",
  templateUrl: "./braintree-payment-methods-model.page.html",
  styleUrls: ["./braintree-payment-methods-model.page.scss"],
})
export class BraintreePaymentMethodModelPage implements OnInit {
  submitted = false;
  public gridDataStore: Object[] | any;
  public accountId;
  @ViewChild("cardInfo") cardInfo: ElementRef | any;
  card: any;
  error: string = "";
  constructor(
    public navCtrl: NavController,
    public httpProvider: HttpProvider,
    public formModule: FormsModule,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private router: Router,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private spinner: SpinnerService
  ) {
    if (navParams != null) {
      this.accountId = navParams.data.accountId;
    }
  }

  onClick(event: any) {
    if (cordova != undefined) {
      if (cordova.plugins != undefined) {
        if (cordova.plugins.Keyboard != undefined) {
          if (cordova.plugins.Keyboard.isVisible) {
            cordova.plugins.Keyboard.close();
          }
        }
      }
    }
  }

  async ngOnInit(): Promise<void> {
    var self = this;
    self.spinner.show("Please wait...");
    var button = document.querySelector("#submit-button") as any;
    let coderGenerateId = this.accountId;
    self.httpProvider.clientTokenGenerate(coderGenerateId).subscribe(
      async (data: any) => {
        braintree.dropin.create(
          {
            authorization: data.body,
            container: "#dropin-container",
            // paypal: {
            //   flow: "vault",
            // },
            // venmo: {
            //   allowNewBrowserTab: false,
            // },
            card: {
              overrides: {
                fields: {
                  number: {
                    placeholder: "**** **** **** ****",
                    formatInput: true,
                  },
                  cvv: {
                    placeholder: "***",
                    formatInput: true,
                  },
                },
              },
            },
          },
          function (createErr: any, instance: any) {
            button.addEventListener("click", function () {
              instance.requestPaymentMethod(function (err: any, payload: any) {
                const paymentDetailData = {
                  account_id: coderGenerateId,
                  payment_token: payload.nonce,
                  last_4_digits: payload.details.lastFour,
                  card_type: payload.type + "-" + payload.details.cardType,
                };
                self.httpProvider
                  .SavePaymentMethod(paymentDetailData)
                  .subscribe(
                    async (data: any) => {
                      if (data != null) {
                        const alert = self.alertCtrl.create({
                          header: "Done",
                          message: "Payment Method Updated Successfully",
                          buttons: ["Ok"],
                        });
                        (await alert).onDidDismiss().then((e) => {
                          window.location.reload();
                        });
                        (await alert).present();
                      }
                    },
                    async (error: any) => {
                      self.spinner.hide();
                      const alert = self.alertCtrl.create({
                        header: "Alert",
                        message: "Something went wrong. Please try again later",
                        buttons: ["Ok"],
                      });
                      (await alert).present();
                    }
                  );
              });
            });
          }
        );
        self.spinner.hide();
      },
      async (error: any) => {
        self.spinner.hide();
        const alert = self.alertCtrl.create({
          header: "Alert",
          message: "Something went wrong. Please try again later",
          buttons: ["Ok"],
        });
        (await alert).present();
      }
    );
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  backButtonAction() {
    this.modalCtrl.dismiss();
  }
}
